import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-experience-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './experience-card.component.html',
  styleUrl: './experience-card.component.scss'
})
export class ExperienceCardComponent {
  @Input() title = 'Retour d\'expérience\nGuénifey by Clésame';
  @Input() buttonText = 'Voir plus';
  @Input() featured = true;
  @Input() compact = false;
  @Output() clicked = new EventEmitter<void>();

  onCardClick(): void {
    this.clicked.emit();
  }
}
